import STabs from "./src/sakura-tabs/src/tabs.vue";
import STab from "./src/sakura-tabs/src/tab.vue";

const components = [STabs, STab];

const install = (app) => {
  components.forEach((component) => {
    app.component(component.name, component);
  });
};

const Init = {
  version: "0.0.1",
  install,
  ...components,
};

export default Init;
